import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { contractConfirmationActions } from '../+state/contract-confirmation.actions';
import { contractConfirmationFeature } from '../+state/contract-confirmation.reducer';
import { selectDisplayNudgingNotification, selectOpenMicarContracts } from '../+state/contract-confirmation.selectors';

@Injectable({ providedIn: 'root' })
export class ContractConfirmationFacade {
  readonly #store = inject(Store);

  public readonly contractConfirmations$ = this.#store.select(contractConfirmationFeature.selectContractConfirmations);
  public readonly error$ = this.#store.select(contractConfirmationFeature.selectError);
  public readonly hasAccepted$ = this.#store.select(contractConfirmationFeature.selectHasAccepted);
  public readonly openMicarContracts$ = this.#store.select(selectOpenMicarContracts);
  public readonly loading$ = this.#store.select(contractConfirmationFeature.selectLoading);
  public readonly shouldDisplayNudgingNotification$ = this.#store.select(selectDisplayNudgingNotification);

  public load(): void {
    this.#store.dispatch(contractConfirmationActions.loadRequiredContractConfirmations());
  }

  public accept(): void {
    this.#store.dispatch(contractConfirmationActions.acceptContracts());
  }
}
